var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skelelton-container"},[_c('FixedSkeleton',{attrs:{"main-widget":_vm.mainWidget,"left-widgets":_vm.leftWidgets,"right-widgets":_vm.rightWidgets}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }